// extracted by mini-css-extract-plugin
module.exports = {"chip":"LegalityChip_chip__Aqc9f","success":"LegalityChip_success__TvVTX","error":"LegalityChip_error__zf1WM","warning":"LegalityChip_warning__Gnb7i"};